import {MessageModel} from '../../libs/shared/core/src/models/api/messageModel';
import {CellsContext} from '../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ConversationBaseModel} from '../models/api/conversationModel';
import {isConversationInTeamOrAssigneeContext} from './models/conversationHelpers';
import {isServerMessage} from './models/messageHelpers';
import {useHasPersistedStorage} from './storageHelpers';

/*
 * Hooks.
 */

export function useCanComposeMessageOffline() {
  const hasPersistedStorage = useHasPersistedStorage();

  return canComposeMessageOffline(hasPersistedStorage);
}

export function useCanShareDraftOffline() {
  return canShareDraftOffline();
}

export function useCanComposeCommentOffline() {
  return canComposeCommentOffline();
}

export function useCanComposeDiscussionOffline() {
  return canComposeDiscussionOffline();
}

export function useCanTakeConversationSeenActionOffline() {
  const hasPersistedStorage = useHasPersistedStorage();

  return canTakeConversationSeenActionOffline(hasPersistedStorage);
}

export function useCanTakeConversationStatusActionOffline(
  cellsContext: CellsContext,
  conversations: ReadonlyArray<ConversationBaseModel>,
) {
  const hasPersistedStorage = useHasPersistedStorage();

  return canTakeConversationStatusActionOffline(hasPersistedStorage, cellsContext, conversations);
}

export function useCanDeleteDraftOffline(draftMessages: ReadonlyArray<MessageModel>) {
  return canDeleteDraftOffline(draftMessages);
}

/*
 * Helpers.
 */

export function canComposeMessageOffline(hasPersistedStorage: boolean) {
  return hasPersistedStorage;
}

export function canShareDraftOffline() {
  return false;
}

export function canComposeCommentOffline() {
  return false;
}

export function canComposeDiscussionOffline() {
  return false;
}

export function canTakeConversationSeenActionOffline(hasPersistedStorage: boolean) {
  return hasPersistedStorage;
}

export function canTakeConversationStatusActionOffline(
  hasPersistedStorage: boolean,
  cellsContext: CellsContext,
  conversations: ReadonlyArray<ConversationBaseModel>,
) {
  return (
    // We must have persisted storage.
    hasPersistedStorage &&
    // And for every conversation...
    conversations.every((conversation) => !isConversationInTeamOrAssigneeContext(cellsContext, conversation))
  );
}

export function canDeleteDraftOffline(draftMessages: ReadonlyArray<MessageModel>) {
  return (
    // For every conversation...
    draftMessages.every(
      // The message cannot be saved on the server.
      (message) => !isServerMessage(message),
    )
  );
}
